import type { ScriptedFixtureCatalog } from "@slot/game-shell";
import { SECRET_BONUS_OFFER_ID } from "../../features/secret-bonus/secretBonusOffer";
import { bigWin } from "./base/big_win";
import { mergeChain } from "./base/merge_chain";
import { mergeDouble } from "./base/merge_double";
import { mergeH1Scatter } from "./base/merge_h1_scatter";
import { mergeLeftover } from "./base/merge_leftover";
import { mergeSingle } from "./base/merge_single";
import { noWin } from "./base/no_win";
import { noWin2 } from "./base/no_win_2";
import { noWin3 } from "./base/no_win_3";
import { secretBonus } from "./base/secret_bonus";
import { fsBonusBuy } from "./feature/fs_bonus_buy";
import { fsMergeTrigger } from "./feature/fs_merge_trigger";
import { fsSecretBonus } from "./feature/fs_secret_bonus";

/**
 * The simulated server's catalog: the base rounds the offline round robin plays (in an order that reads well when
 * playing by hand, a dead spin after every win; the Secret Bonus lands third), and the bought sessions, routed by the
 * purchase's id: the Bonus Buy's eight free spins, the Secret Bonus's twelve.
 */
export function createFixtureCatalog(): ScriptedFixtureCatalog {
  return {
    baseFixtures: [
      mergeSingle(), noWin(), secretBonus(), mergeChain(), noWin2(), mergeDouble(), noWin3(), mergeLeftover(), noWin(),
      mergeH1Scatter(), noWin2(), bigWin(), noWin3(), fsMergeTrigger(), noWin(),
    ],
    featureFixtures: [fsBonusBuy()],
    featureFixturesById: { free_spins_buy: [fsBonusBuy()], [SECRET_BONUS_OFFER_ID]: [fsSecretBonus()] },
  };
}
